import { Components, Theme } from '@mui/material'

export const MenuOverrides = (theme: Theme): Components['MuiMenu'] => ({
  defaultProps: {},
  styleOverrides: {
    root: {},
  },
})
